import React from "react";
import { Link } from "react-scroll";
import { Github, Linkedin, Twitter, Mail } from "lucide-react";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-portfolio-dark text-white py-12">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo & Description */}
          <div className="space-y-4">
            <Link
              to="hero"
              spy={true}
              smooth={true}
              duration={500}
              className="text-xl font-bold cursor-pointer"
            >
              <img src="/logo-anas-bg.png" alt="Logo" className="" />
            </Link>
            <p className="text-gray-300 text-sm">
              A passionate software developer dedicated to creating beautiful,
              functional, and accessible web applications.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-center">
              Quick Links
            </h3>
            <ul className="space-y-2 flex flex-col items-center">
              <li>
                <Link
                  to="about"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="projects"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Projects
                </Link>
              </li>
              <li>
                <Link
                  to="skills"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Skills
                </Link>
              </li>
              <li>
                <Link
                  to="experience"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Experience
                </Link>
              </li>
              <li>
                <Link
                  to="contact"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-center">Connect</h3>
            <div className="flex space-x-4 mb-4 justify-center">
              <a
                href="https://github.com/anasch132"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-portfolio-blue text-white p-2 rounded-full transition-colors duration-300"
                aria-label="GitHub"
              >
                <Github size={18} />
              </a>
              <a
                href="https://linkedin.com/in/anas-chatouane"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-portfolio-blue text-white p-2 rounded-full transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="https://x.com/Anas_ch_dev"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-portfolio-blue text-white p-2 rounded-full transition-colors duration-300"
                aria-label="Twitter"
              >
                <Twitter size={18} />
              </a>
              <a
                href="mailto:anasch132@gmail.com"
                className="bg-white/10 hover:bg-portfolio-blue text-white p-2 rounded-full transition-colors duration-300"
                aria-label="Email"
              >
                <Mail size={18} />
              </a>
            </div>
            <p className="text-sm text-gray-300 text-center">
              Feel free to reach out for collaborations or just a friendly
              hello!
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-300">
            © {currentYear} Anas Chatouane. All rights reserved.
          </p>
          <p className="text-xs text-gray-400 mt-2 md:mt-0 text-center">
            Designed and built with React & Tailwind CSS by{" "}
            <span className="text-portfolio-accent"> Anas Chatouane </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
